import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_ADS, {
      queryParams: {
        position: payload?.position || undefined,
        active: payload?.active !== undefined ? payload.active : undefined,
      }
    })
  },

  parse(raw = {}, payload = {}) {
    if (raw.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || 'Failed to fetch ads',
        data: null,
      }
    }

    const res = raw.data || {}
    const ads = Array.isArray(res) ? res : (Array.isArray(res.data) ? res.data : [])

    window.totalAds = ads.length
    const formatted = ads.map(el => {
      const meta = el.metadata || {}

      const coupon = el.coupon || meta.coupon || null
      const dishId = el.dishId || meta.dishId || null
      const restaurantId = el.restaurantId || meta.restaurantId || null
      const internalPage = el.internalPage || meta.internalPage || null
      const feature = el.feature || meta.feature || null
      const linkUrl = el.link || el.linkUrl || el.url || null
      const targetAudience = Array.isArray(meta.targetAudience)?'all': meta.targetAudience
      const order = meta.order !== undefined ? meta.order : (el.order ?? 0)

      const actionType = el.actionType || (
        linkUrl ? 'external' :
        internalPage ? 'internal' :
        coupon ? 'coupon' :
        dishId ? 'dish' :
        restaurantId ? 'restaurant' :
        feature ? 'feature' : 'unknown'
      )

      return {
        ...el,
        id: el.id,
        order,
        title: el.title || '',
        description: el.description || '',
        picture: el.imageUrl || el.picture || '',
        imageUrl: el.imageUrl || el.picture || '',
        linkUrl,
        url: linkUrl,
        actionType,
        targetAudience,
        internalPage,
        coupon,
        dishId,
        restaurantId,
        feature,
        isActive: el.active !== undefined ? el.active : el.isActive,
        status: (el.active || el.isActive) ? 'active' : 'inactive',
        startDate: el.startDate || null,
        endDate: el.endDate || null,
      }
    })

    let data = formatted
    const searchTerm = (payload?.search || '').toString().trim().toLowerCase()
    if (searchTerm) {
      data = data.filter(el => {
        return Object.values(el).some(val => 
          val && typeof val !== 'object' && String(val).toLowerCase().includes(searchTerm)
        )
      })
    }

    const { sortKey="order", sortOrder } ={}
    console.log("🚀 ~ sortKey:", sortKey)
    if (sortKey) {
      const order = sortOrder === 'desc' ? -1 : 1
      data = [...data].sort((a, b) => {
        const valA = a?.[sortKey]
        const valB = b?.[sortKey]
        if (typeof valA === 'string' && typeof valB === 'string') return valA.localeCompare(valB) * order
        if (typeof valA === 'number' && typeof valB === 'number') return (valA - valB) * order
        return 0
      })
    }

    const { page = 0, limit = 20 } = payload || {}
    const paginated = data.slice(page * limit, (page + 1) * limit)

    return {
      statusCode: 200,
      message: 'Ok',
      data: {
        total: data.length,
        result: paginated,
      },
    }
  },
}